import './DownloadConfirmationModal.scss'
import React, { useState } from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Typography,
  Checkbox,
  FormControlLabel,
  Button,
  Link,
} from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import { Trans, useTranslation } from 'react-i18next'

interface DownloadConfirmationModalProps {
  open: boolean
  onClose: () => void
  onConfirm: () => void
}

const DownloadConfirmationModal = ({
  open,
  onClose,
  onConfirm,
}: DownloadConfirmationModalProps) => {
  const { t }: any = useTranslation()
  const [accepted, setAccepted] = useState(false)

  const handleClose = () => {
    setAccepted(false)
    onClose()
  }

  const handleConfirm = () => {
    if (accepted) {
      onConfirm()
      setAccepted(false)
      onClose()
    }
  }

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="download-confirmation-title"
      maxWidth="md"
      fullWidth
    >
      <DialogTitle
        className="download-confirmation-modal-title"
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Typography
          className="download-confirmation-modal-title-text"
          component="span"
        >
          {t('downloadConfirmation.title')}
        </Typography>
        <IconButton className="close-modal" onClick={handleClose} size="small">
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent className="download-confirmation-content" dividers>
        <Typography variant="body1" className="confirmation-text">
          <Trans
            i18nKey="downloadConfirmation.text"
            components={{
              a: <Link href="/metodologia" target="_blank" />,
            }}
          />
        </Typography>
        <FormControlLabel
          control={
            <Checkbox
              checked={accepted}
              onChange={(e) => setAccepted(e.target.checked)}
              sx={{
                color: '#95c11c',
                '&.Mui-checked': {
                  color: '#95c11c',
                },
              }}
            />
          }
          label={t('downloadConfirmation.checkboxLabel')}
          className="confirmation-checkbox"
        />
      </DialogContent>
      <DialogActions className="download-confirmation-actions">
        <Button onClick={handleClose} className="cancel-button">
          {t('downloadConfirmation.cancel')}
        </Button>
        <Button
          onClick={handleConfirm}
          disabled={!accepted}
          className="confirm-button"
          variant="contained"
        >
          {t('downloadConfirmation.download')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default DownloadConfirmationModal

